import { render, staticRenderFns } from "./Receiving.vue?vue&type=template&id=905050d0&scoped=true&"
import script from "./Receiving.vue?vue&type=script&lang=js&"
export * from "./Receiving.vue?vue&type=script&lang=js&"
import style0 from "./Receiving.vue?vue&type=style&index=0&id=905050d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "905050d0",
  null
  
)

export default component.exports